import { BasicButton } from 'thrive-components'



const WhitelistButtonPanel = ({onViewRequests, onEnableClick, canViewRequests, onCreateCodeClick, canCreateRecoveryCode}:{onViewRequests: ()=>void, onEnableClick: ()=>void, canViewRequests: boolean, onCreateCodeClick: () => void, canCreateRecoveryCode: boolean}) => {  

    return(
        <div className="whitelist-button-container">
            <BasicButton 
                content={"Enable IP Whitelist"} 
                onButtonClick={onEnableClick}
                ariaLabel={'Enable IP Whitelist'}
            />
            {canViewRequests && <>
                <BasicButton 
                    content={"View Requests"} 
                    onButtonClick={onViewRequests}
                    ariaLabel={'View Requests'}
                />

                <BasicButton 
                    className='create-code-button'
                    content={"Create Code"} 
                    ariaLabel={'Create Code'} 
                    onButtonClick={onCreateCodeClick} 
                    isDisabled={!canCreateRecoveryCode}
                />
            </>}
            
        </div>
    )
}

export default WhitelistButtonPanel